import { render, staticRenderFns } from "./OkModal.vue?vue&type=template&id=5004c66d&scoped=true&"
import script from "./OkModal.vue?vue&type=script&lang=ts&"
export * from "./OkModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../adminspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5004c66d",
  null
  
)

export default component.exports